import React, { useRef, useEffect, useState } from 'react';
import { compact } from 'lodash';
import classnames from 'classnames';
import StrapiButton from '../../StrapiLink/StrapiButton';
import { ScrollingStatementComponentFragment, LinkComponentFragment } from '../../../../graphql.schema';

import * as styles from './index.module.scss';

type StrapiScrollingStatementComponentPropType = ScrollingStatementComponentFragment & {
  hasRTL?: boolean;
  optional_link: any
};
export const StrapiScrollingStatementComponent: React.FC<StrapiScrollingStatementComponentPropType> = ({
  title,
  scrollingStatements,
  optional_link,
  imageLeft,
  imageRight,
  hasRTL = false,
}) => {
  const statementsRef = useRef([]) as React.MutableRefObject<HTMLInputElement[]>;
  const [activeStatement, setActiveStatment] = useState('');
  const link =  optional_link;
  const scrollHandler = () => {
    const activeElement = statementsRef.current.find(
      (element) => element?.getBoundingClientRect()?.top > 100 && element?.getBoundingClientRect()?.top < 300,
    );
    if (activeElement) {
      setActiveStatment(activeElement.id);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', scrollHandler, true);
    return () => {
      window.removeEventListener('scroll', scrollHandler, true);
    };
  }, []);

  return (
    <div className={styles.scrollingStatements}>
      <div className="columns">
        <div className="column is-5-widescreen is-6-desktop is-5-tablet">
          <div className="columns">
            <div
              className={classnames(
                'column is-8 is-offset-2-widescreen is-offset-4-desktop is-offset-2-tablet',
                styles.contentLeft,
                hasRTL ? styles.contentLeftRTL : '',
              )}
            >
              <img
                className={classnames('is-hidden-touch', styles.imageLeft)}
                alt={imageLeft?.alternativeText ?? imageRight?.caption ?? ''}
                src={imageLeft?.url}
                width={imageLeft?.width}
                height={imageLeft?.height}
                loading="lazy"
              />
              <img
                className={classnames(styles.imageRight, 'is-hidden-mobile mb-5')}
                alt={imageRight?.alternativeText ?? imageRight?.caption ?? ''}
                src={imageRight?.url}
                width={imageRight?.width}
                height={imageRight?.height}
                loading="lazy"
              />
              <StrapiButton
                className="is-hidden-mobile"
                type="secondary"
                key={optional_link?.title}
                {...(optional_link as LinkComponentFragment)}
              />
            </div>
          </div>
        </div>
        <div
          className={classnames(
            'column is-hidden-mobile is-7-widescreen is-6-desktop is-7-tablet',
            styles.scrollingRight,
            hasRTL ? styles.scrollingContentRTL : '',
          )}
        >
          <h2 className={classnames('mb-6 title brand-a', styles.statementHeading)}>{title}</h2>
          {compact(scrollingStatements)?.map(({ statement, subHeading }, i) => (
            <div key={statement}>
              <h3
                id={`statement-${i}`}
                ref={(el) => (statementsRef.current[i] = el as HTMLInputElement)}
                className={`title is-3 mb-4 ${activeStatement === `statement-${i}` ? 'brand-a' : 'black-4'}`}
              >
                {statement}
              </h3>
              <p
                className={classnames(
                  styles.statementSubHeading,
                  `is-text-2 ${activeStatement === `statement-${i}` ? 'brand-a' : 'black-4'}`,
                )}
              >
                {subHeading}
              </p>
            </div>
          ))}
        </div>
        <div className="is-hidden-tablet">
          <div className="is-flex is-align-items-baseline is-justify-content-center">
            <img
              className={classnames('mb-5', styles.imageRightMobile)}
              alt={imageRight?.alternativeText ?? imageRight?.caption ?? ''}
              src={imageRight?.url}
              width={imageRight?.width}
              height={imageRight?.height}
              loading="lazy"
            />
            <img
              className={styles.imageLeftMobile}
              alt={imageLeft?.alternativeText ?? imageRight?.caption ?? ''}
              src={imageLeft?.url}
              width={imageLeft?.width}
              height={imageLeft?.height}
              loading="lazy"
            />
          </div>
          <div className="p-3">
            <h2 className="title brand-a">{title}</h2>
            <StrapiButton type="secondary" key={optional_link?.title} {...(optional_link as LinkComponentFragment)} />
          </div>
        </div>
      </div>
    </div>
  );
};
